<template>
  <div class="c_copy_to_clipboard">
    <label class="c_copy_to_clipboard__label" for="copyToClipboard" @click="copyToClipboard(copyText)">
      {{ copyLabel }}
    </label>
    <input class="c_copy_to_clipboard__input" id="copyToClipboard" type="text" :value="copyText" readonly />
    <Button class="c_copy_to_clipboard__button" @onClick="copyToClipboard(copyText)" label-text="Copy" />
    <span class="c_copy_to_clipboard__success" aria-live="assertive" v-if="copySuccessful">Copied Successful</span>
  </div>
</template>

<script>
import { getFullUrl, log } from 'JS/global.js';
import Button from 'Components/button/Button.vue';
export default {
  components: {
    Button,
  },
  data() {
    return {
      copySuccessful: false,
    };
  },
  props: {
    copyLabel: {
      type: String,
      default: 'Copy',
    },
    copyText: {
      type: String,
      required: true,
    },
  },
  computed: {},
  methods: {
    copyToClipboard: function(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.copySuccessful = true;
        setTimeout(() => {
          this.copySuccessful = false;
        }, 2000);
      });
    },
  },
  created() {},
  mounted() {},
};
</script>

<style lang="scss">
.c_copy_to_clipboard {
  $self: &;
  position: relative;
  padding-top: px_to_rem(10);
  @at-root #{$self}__success {
    position: absolute;
    top: calc(100% + #{px_to_rem(5)});
    left: 0;
  }
}
</style>
